import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useMutation } from '@apollo/client';
import Loading from './Loading'; // Adjust the path as necessary


const DeleteDialog = ({isOpen, onClose, subject, onConfirm}) => {

  // Assuming subject.function is a GraphQL mutation string
  const [deleteFunction, { loading, error }] = useMutation(subject.function); // eslint-disable-line no-unused-vars

  const handleDelete = async () => {
    if (subject && subject.function != null) {
      try {
        // Execute the delete mutation
        const response = await deleteFunction({ variables: { subjectId: subject.id } });

        // If needed, you can process the response here
        onConfirm();
        console.log(response);
      } catch (err) {
        console.error("Deletion error:", err);
      }
    }
    onClose();
  };

  if (subject.allowed === null) {
    return <Loading />;}

  else if (subject.allowed === false) {
    return (
      <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="cannot-delete-dialog-title"
      aria-describedby="cannot-delete-dialog-description"
    >
      <DialogTitle id="cannot-delete-dialog-title">
        {subject.name + " ne može biti izbrisan"}
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="cannot-delete-dialog-description">
          {subject.reason}
        </DialogContentText>
      </DialogContent>
      
      <DialogActions>
        <Button 
          onClick={onClose}
          autoFocus 
          size='large'  
          sx={{
            margin: '8px', 
            paddingX:'10px'
          }}
        >
          OK
        </Button>
      </DialogActions>
      </Dialog>
      );}
  else {
    return ( 
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Use/delete " + subject.name + "?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {"Selected " + subject.name + " will be permanently lost."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={onClose}
            size='large' 
            sx={{
              margin: '8px', 
              paddingX:'10px',
              borderColor: 'var(--black1)',
              borderWidth: '1px',
              borderStyle: 'solid',
              color: 'var(--black1)'
            }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained"
            onClick={handleDelete}
            autoFocus 
            size='large'  
            sx={{
              margin: '8px', 
              paddingX:'10px', 
              borderColor: 'var(--black1)',
              borderWidth: '1px',
              borderStyle: 'solid',
              backgroundColor: 'var(--black1)',
              color: 'var(--yellow1)'
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
    }
}

export default DeleteDialog;
